import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/manage/$siteId/phpmyadmin')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/n/manage/$siteId/phpmyadmin',
      params: { siteId: params.siteId },
      replace: true,
    });
  },
});
